<div class="holder">
    <img [src]="imgUrl" alt="">
    <div class="text">
        <h4>{{title}}</h4>
        <p>{{text}}</p>
    </div>
</div>